<template>
    <div class="tile switch-tile row align-items-center">
        <div class="col" @click="onClick">
            <slot>
                <label>{{ title }}</label>
            </slot>
            <div class="text-muted small" v-if="subtitle">{{ subtitle }}</div>
        </div>
        <div class="col-auto"><toggle :on-label="onLabel" :off-label="offLabel" v-model="on" /></div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        subtitle: String,
        value: [Boolean, String],
        onLabel: {
            type: String,
            default: 'YES',
        },
        offLabel: {
            type: String,
            default: 'NO',
        }
    },
    data: function() {
        return {
            on: this.value || false
        }
    },
    watch: {
        value: function(value) {
            this.on = value;
        },
        on: function() {
            this.$emit('input', this.on);
        }
    },
    methods: {
        onClick: function() {
            this.on = !this.on;
        }
    }
}
</script>

<style lang="scss" scoped>
label {
    color: rgba(0,0,0,0.87);
    margin: 0;
}

.switch-tile > div {
    padding-bottom: 8px;
    padding-top: 8px;
}
</style>